angular.module('impactx.cscontract').controller('CSCOrdersCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'ToastService',
    'BackService',
    'TranslationService',
    'ToolbarService',
    'PartialDialogsService',
    CSCOrdersCtrl
]);

function CSCOrdersCtrl($scope, dataGen, $routeParams, ToastService, BackService, TranslationService, ToolbarService, PartialDialogsService) {
    var self = this;

    var save = function (resultScope) {
        return dataGen.postAsForm(resultScope, {orderData: $scope.data}, "/cscontract/orders/save");
    };

    var getData = function () {
        dataGen.getData($scope, {cscId: $routeParams.cscId}, "/cscontract/orders/view").then(function () {
            self.changeOneItemPerOrder();
            defineButtons();
        })
    };

    self.saveAndBack = function ($event) {
        return save($scope).then(function () {
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            PartialDialogsService.showDialog($event, PartialDialogsService.TYPE.CONTRACT, $routeParams.cscId, 'cscorders', $routeParams.preSetId ? $routeParams.preSetId : 0);
        });
    };

    self.regroupNow = function () {
        var resultScope = {};
        return save(resultScope).then(function () {
            dataGen.postAsForm(resultScope, {cscId: $routeParams.cscId}, "/cscontract/orders/regroup").then(function () {
                ToastService.openStandardToast($scope.trns.regroupSuccess);
                getData();
            });
        });
    };

    self.showFileUpload = function () {
        if ($scope.data) {
            return ($scope.data.fileUploadDemand || $scope.data.fileUploadDisposition || $scope.data.fileUploadRequest);
        }
        return false;
    };

    var setGrouping = function (flags) {
        angular.forEach($scope.data.groupingFlags, function (entry) {
            if ($scope.data.oneItemPerOrder.value && entry.flagValue === $scope.data.groupingFlagBasket) {
                entry.readOnly = true;
                entry.value = true;
            }
            else {
                entry.readOnly = false;
                entry.value = (flags & entry.flagValue) > 0;
            }
        });
    };

    self.setForCBL = function () {
        setGrouping($scope.data.groupingFlagCBL);
    };

    self.setForAMEX = function () {
        setGrouping($scope.data.groupingFlagAMEX);
    };

    self.changeOneItemPerOrder = function () {
        angular.forEach($scope.data.groupingFlags, function (entry) {
            if ($scope.data.oneItemPerOrder.value && entry.flagValue === $scope.data.groupingFlagBasket) {
                entry.readOnly = true;
                entry.value = true;
            }
        });
    };

    getData();

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.saveAndBack,
                type: 'validation',
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.regroup,
                action: self.regroupNow,
                type: 'validation',
                condition: canRegroup,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.forCBL,
                action: self.setForCBL,
                type: 'dialogaction',
                condition: canSetForCBL
            },
            {
                label: $scope.trns.forAMEX,
                action: self.setForAMEX,
                type: 'dialogaction',
                condition: canSetForAMEX
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function canRegroup() {
        return $scope.data.numWaitingOrders.value && !$scope.data.disableOrderCreation.value;
    }

    function isMaster() {
        return !$scope.data.isSlave;
    }

    function canSetForCBL() {
        return isMaster() && !$scope.data.isAMEX;
    }

    function canSetForAMEX() {
        return isMaster() && $scope.data.isAMEX;
    }
}